import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CommonService } from 'src/app/modules/shared/imports/services/common.service';
import { hideSpinner, showSpinner,getCurrentUser } from 'src/app/core/services/functions.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { LogisticaService } from '../services/logistica.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { CokyHelperDialogComponent } from 'src/app/modules/shared/imports/components/dialog/dialog.component';
import { DetalleOrden, DetalleOrdenTransformado } from '../models/detalle-orden.model';
import { ModalGestionarServiciosDiaComponent, GestionarServiciosDiaResultado } from '../modal-gestionar-servicios-dia/modal-gestionar-servicios-dia.component';



interface Poligono {
  id: string;
  codigo: string;
  descripcion: string;
  cubicajeMax: number;
  ordenesMax: number;
  cubicajeAct: number;
  ordenesAct: number;
  estado?: 'abierto' | 'cerrado';
  cierre_automatico?: 'abierto' | 'cerrado';
  fecha?: Date;
}

@Component({
  selector: 'app-dashboard-poligono',
  templateUrl: './dashboard-poligono.component.html',
  styleUrls: ['./dashboard-poligono.component.scss']
})
export class DashboardPoligonoComponent implements OnInit, OnDestroy {
  // CAM=05, CAP=10, TAR (Taller Recogida)=07, TAE (Taller Entrega)=08,
  // DEV (Devolución)=06 y NTC (Nota Crédito)=06 en CALENDARIO_CITAS_INTEGRAL.COD_MODELO. Taller se
  // maneja separado porque recogida y entrega tienen citas y fechas de
  // picking independientes.
  private readonly TIPO_SOL_LABELS: {[k: string]: string} = {
    CAM: 'Cambio Total',
    CAP: 'Cambio Parcial',
    TAR: 'Taller - Recogida',
    TAE: 'Taller - Entrega',
    DEV: 'Devolución',
    NTC: 'Nota Crédito',
  };
  private readonly TIPO_SOL_CLASES: {[k: string]: string} = {
    CAM: 'tc-sol-cam',
    CAP: 'tc-sol-cap',
    TAR: 'tc-sol-tar',
    TAE: 'tc-sol-tae',
    DEV: 'tc-sol-dev',
    NTC: 'tc-sol-ntc',
  };
  filtroBodega: FormControl = new FormControl();
  fechaControl: FormControl = new FormControl();
  cod_bodega: any;
  fechaSeleccionada: Date | null = null;
  form: FormGroup;
  bodegasFiltradas: Observable<Item[]>;
  storeBodegas: Item[] = [];
  actualizacionAutomatica: any = null;
  poligonos: Poligono[] = [];
  poligonosMensuales: Poligono[] = [];
  vistaMensual: boolean = false;
  usuario: any;
  nombresPoligonos: string[] = ['DIF ACC BAQ - SOL', 'CAUCACIA Y OTROS', 'BARRANCABERMEJA', 'SANTANDER', 'CUNDINAMARCA', 'ANTIOQUIA', 'COSTA 2', 'COSTA 1'];
  fechasDelMes: Date[] = [];
  
  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private helpers: HelpersService,
    private logisticaService: LogisticaService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) {
    this.form = this.formBuilder.group({
      cod_bodega: [''],
      fecha: [null]
    });
    
    // Suscribirse a cambios en el control de fecha
    this.fechaControl.valueChanges.subscribe(date => {
      this.fechaSeleccionada = date;
      this.form.patchValue({ fecha: date });
    });
  }

  async ngOnInit(): Promise<void> {
    await this.cargarBodegas();
    this.fechaControl.setValue(new Date());
    this.generarDatosMensuales();
  }
  
  async cargarBodegas(): Promise<void> {
    try {
      showSpinner();
      const bodegas = await this.commonService.findAllBodegas();
      this.storeBodegas = bodegas.data.map((d) => {
        return {
          cod: d.c_bod,
          nombre: d.nom
        };
      });

      // Configurar el filtro de bodegas
      this.bodegasFiltradas = this.filtroBodega.valueChanges.pipe(
        startWith(''),
        map(value => this._filtrarBodegas(value || ''))
      );
      
      console.log('Bodegas cargadas:', this.storeBodegas);
    } catch (error) {
      console.error('Error al cargar bodegas:', error);
    } finally {
      hideSpinner();
    }
  }
  
  private _filtrarBodegas(value: string): Item[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    return this.storeBodegas.filter(bodega =>
      bodega.nombre.toLowerCase().includes(filterValue) ||
      bodega.cod.toLowerCase().includes(filterValue)
    );
  }

  getAlertaClass(porcentaje: number): string {
    if (porcentaje >= 100) return 'critical';
    if (porcentaje >= 80) return 'normal';
    if (porcentaje >= 50) return 'progress-alert';
    return 'low';
  }

  getPorcentajeNum(actual: number, maximo: number): number {
    return Math.min(100, (actual / maximo) * 100);
  }

  getPorcentaje(actual: number, maximo: number): string {
    return this.getPorcentajeNum(actual, maximo).toFixed(1);
  }

  determinarEstado(estadoDia: string): 'abierto' | 'cerrado' {
    if (!estadoDia) return 'cerrado';
    const estado = estadoDia.toUpperCase();
    return (estado === 'ABIERTO' || estado === 'A') ? 'abierto' : 'cerrado';
  }

  async BuscarCapacidadesTransporte(mostrarSpinner: boolean = true, iniciarActualizacion: boolean = true): Promise<void> {
    try {
      if (mostrarSpinner) showSpinner();
      const fechaFormateada = this.fechaSeleccionada ? 
        this.formatearFecha(this.fechaSeleccionada) : 
        this.formatearFecha(new Date());
      
      if (!this.cod_bodega) {
        this.helpers.notifications.errorMessage("Los campos son requeridos");
        return;
      }
      
      const res = await this.logisticaService.obtener_capacidades_poligono('JA', fechaFormateada, this.cod_bodega);
      console.log('res', res);
      
      if (res.success && res.data && res.data.length > 0) {
        // Actualizar los datos de los polígonos con la información recibida
        this.actualizarPoligonosConDatos(res.data);
        
        // Iniciar actualización automática solo si se solicita y no está ya activa
        if (iniciarActualizacion) {
          this.iniciarActualizacionAutomatica();
        }
      } else {
        // Si no hay datos, mostrar mensaje
        if (mostrarSpinner) this.helpers.notifications.infoMessage("No se encontraron datos para los criterios seleccionados");
      }
    } catch (error) {
      console.error('Error al buscar capacidades:', error);
      if (mostrarSpinner) this.helpers.notifications.errorMessage("Error al obtener datos de capacidades");
    } finally {
      if (mostrarSpinner) hideSpinner();
    }
  }
  
  iniciarActualizacionAutomatica(): void {
    // Si ya existe un intervalo, no crear otro
    if (this.actualizacionAutomatica) return;
    
    // Crear un intervalo que se ejecute cada minuto
    this.actualizacionAutomatica = setInterval(() => {
      // Solo actualizar si tenemos bodega y fecha
      if (this.cod_bodega && this.fechaSeleccionada) {
        console.log('Actualizando datos automáticamente...');
        this.BuscarCapacidadesTransporte(false, false); // No mostrar spinner ni reiniciar el intervalo
      }
    }, 60000); // 60000 ms = 1 minuto
    
    this.helpers.notifications.infoMessage("Actualización automática iniciada. Los datos se actualizarán cada minuto.");
  }
  
  detenerActualizacionAutomatica(): void {
    if (this.actualizacionAutomatica) {
      clearInterval(this.actualizacionAutomatica);
      this.actualizacionAutomatica = null;
      console.log('Actualización automática detenida');
    }
  }
  
  
  actualizarPoligonosConDatos(data: any[]): void {
    console.log('Datos recibidos para actualizar:', data);
    
    // Crear polígonos dinámicamente desde los datos de la API, ordenados alfabéticamente
    this.poligonos = data.map(item => ({
      id: item.POLIGONO?.toString() || '',
      codigo: item.COD_POLIGONO || '',
      descripcion: item.NOMBRE_POLIGONO || '',
      cubicajeAct: item.CUBICAJE_OCUPADO || 0,
      ordenesAct: item.CANT_ORDENES_OCUPADO || 0,
      cubicajeMax: item.CUBICAJE_TOTAL || 0,
      ordenesMax: item.CANTIDAD_ORD_TOTAL || 0,
      estado: this.determinarEstado(item.ESTADO_DIA),
      cierre_automatico: (item.CIERRE_AUTOMATICO === 'S' ? 'abierto' : 'cerrado') as 'abierto' | 'cerrado'
    })).sort((a, b) => a.descripcion.localeCompare(b.descripcion, 'es', { sensitivity: 'base' }));

    console.log('Polígonos creados dinámicamente:', this.poligonos);
  }
  
  formatearFecha(fecha: Date): string {
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const anio = fecha.getFullYear();
    return `${anio}-${mes}-${dia}`;
  }

  

  onBodegaSelected(event: any): void {
    const selectedBodega = event.option.value;
    this.cod_bodega = selectedBodega.cod;
    // Actualizar el valor en el formulario
    this.form.patchValue({
      cod_bodega: selectedBodega.cod
    });
    console.log('Bodega seleccionada:', selectedBodega.cod);
    
    // Si está en vista mensual, regenerar datos
    if (this.vistaMensual) {
      this.generarDatosMensuales();
    }
    
    // Filtrar los polígonos por bodega
    this.filtrarPoligonos(selectedBodega.cod);
  }

  // Método para mostrar el valor seleccionado en el autocomplete
  displayBodega(bodega?: Item): string {
    return bodega ? `${bodega.cod} - ${bodega.nombre}` : '';
  }
  
  // Método para filtrar polígonos por bodega (implementación básica)
  filtrarPoligonos(codigoBodega: string): void {
    console.log('Filtrando polígonos para bodega:', codigoBodega);
    // Aquí implementarías la lógica para filtrar los polígonos según la bodega seleccionada
  }

  onToggleChange(event: MatSlideToggleChange, poly: Poligono): void {
    if (!event.checked) {
      // Mostrar modal de confirmación antes de cerrar
      this.helpers.notifications.warningDialog(
        'Confirmar cierre',
        '¿Está seguro que desea cerrar el día para el polígono y todos los calendarios de cita asociados a éste?',
        'Aceptar',
        () => this.toggleCierreAutomatico(event, poly),
        '450px'
      );
    } else {
      // Si se intenta abrir, ejecutar directamente
      this.toggleCierreAutomatico(event, poly);
    }
  }

  async toggleCierreAutomatico(event: MatSlideToggleChange, poly: Poligono):Promise<void>{
    poly.cierre_automatico = event.checked ? 'abierto' : 'cerrado';
    const usuario = getCurrentUser().usuario_aplicativo || '';
    const fechaFormateada = this.vistaMensual && poly.fecha ? 
      this.formatearFecha(poly.fecha) : 
      (this.fechaSeleccionada ? this.formatearFecha(this.fechaSeleccionada) : this.formatearFecha(new Date()));
    
    if (!event.checked) {
      // Cerrar el polígono
      poly.estado = 'cerrado';
      
      try{
        const res = await this.logisticaService.cierre_poligono_log('JA',poly.id,this.cod_bodega,fechaFormateada,usuario,'Tablero_Poligono')
        if(res.success){
          this.helpers.notifications.successMessage(`Polígono ${poly.codigo} cerrado correctamente para la fecha ${fechaFormateada}`);
        }else{
          this.helpers.notifications.errorMessage(res.message);
        }
      }catch (error) {
        console.error('Error al cerrar polígono:', error);
        this.helpers.notifications.errorMessage("Error al cerrar el polígono");
      } finally {
        hideSpinner();
      }
    } else {
      // Abrir el polígono
      poly.estado = 'abierto';
      
      try{
        const res = await this.logisticaService.apertura_poligono_log('JA',poly.id,this.cod_bodega,fechaFormateada,usuario,'Tablero_Poligono')
        if(res.success){
          this.helpers.notifications.successMessage(`Polígono ${poly.codigo} abierto correctamente para la fecha ${fechaFormateada}`);
        }else{
          this.helpers.notifications.errorMessage(res.message);
        }
      }catch (error) {
        console.error('Error al abrir polígono:', error);
        this.helpers.notifications.errorMessage("Error al abrir el polígono");
      } finally {
        hideSpinner();
      }
    }
  }

  ngOnDestroy(): void {
    // Limpiar el intervalo cuando el componente se destruya
    this.detenerActualizacionAutomatica();
  }
  
  async obtenerDetalle(id_poligono: string): Promise<void> {
    try {
      if (!this.cod_bodega) {
        this.helpers.notifications.errorMessage("Debe seleccionar una bodega");
        return;
      }
      
      showSpinner();
      const fechaFormateada = this.fechaSeleccionada ? 
        this.formatearFecha(this.fechaSeleccionada) : 
        this.formatearFecha(new Date());
      const res = await this.logisticaService.detalle_ordenes(id_poligono, this.cod_bodega, 'JA',fechaFormateada);
      console.log('res', res);
      
      if (res.success && res.data && res.data.length > 0) {
        this.generarExcel(res.data, id_poligono);
      } else {
        this.helpers.notifications.infoMessage("No se encontraron órdenes para el polígono seleccionado");
      }
    } catch (error) {
      console.error('Error al obtener detalle:', error);
      this.helpers.notifications.errorMessage("Error al obtener detalle de órdenes");
    } finally {
      hideSpinner();
    }
  }

  private transformarDatosOrden(datos: DetalleOrden[]): DetalleOrdenTransformado[] {
    return datos.map(item => ({
      'Número de Orden': item.NUM_ORDEN || '',
      'Pedido SAP': item.NUM_PEDIDO_SAP || 'Sin pedido SAP',
      'Departamento': item.DEPARTAMENTO_DESPACHO || '',
      'Municipio': item.MUNICIPIO_DESPACHO || '',
      'Código Zona SAP': item.CODIGO_ZONA_SAP || '',
      'Barrio': item.BARRIO_DESPACHO || '',
      'Código Producto': item.COD_PRODUCTO || '',
      'Nombre Producto': item.NOMBRE_PRODUCTO || '',
      'Cantidad': item.CANTIDAD || 0,
      'Cubicaje Total': item.CUBICAJE_TOTAL || 0,
      'Tipo de Orden': item.TIPO_ORDEN || '',
      'Polígono': item.NOMBRE_POLIGONO || '',
      'Fecha Picking': item.FECHA_PICKING ? new Date(item.FECHA_PICKING).toLocaleDateString('es-CO') : ''
    }));
  }

  private generarResumenOrdenes(datos: DetalleOrden[]) {
    const resumen = {
      totalOrdenes: datos.length,
      totalCubicaje: datos.reduce((sum, item) => sum + (item.CUBICAJE_TOTAL || 0), 0),
      tiposOrden: {} as { [key: string]: number },
      departamentos: {} as { [key: string]: number },
      productos: {} as { [key: string]: number }
    };

    datos.forEach(item => {
      // Contar tipos de orden
      const tipoOrden = item.TIPO_ORDEN || 'Sin tipo';
      resumen.tiposOrden[tipoOrden] = (resumen.tiposOrden[tipoOrden] || 0) + 1;

      // Contar departamentos
      const departamento = item.DEPARTAMENTO_DESPACHO || 'Sin departamento';
      resumen.departamentos[departamento] = (resumen.departamentos[departamento] || 0) + 1;

      // Contar productos
      const producto = item.NOMBRE_PRODUCTO || 'Sin producto';
      resumen.productos[producto] = (resumen.productos[producto] || 0) + 1;
    });

    return resumen;
  }

  generarExcel(datos: DetalleOrden[], id_poligono: string): void {
    // Importar la biblioteca necesaria para Excel
    import('xlsx').then(XLSX => {
      // Transformar los datos para mejorar la presentación
      const datosTransformados = this.transformarDatosOrden(datos);
      
      // Crear una hoja de trabajo
      const worksheet = XLSX.utils.json_to_sheet(datosTransformados);
      
      // Ajustar el ancho de las columnas
      const columnWidths = [
        { wch: 20 }, // Número de Orden
        { wch: 15 }, // Pedido SAP
        { wch: 20 }, // Departamento
        { wch: 20 }, // Municipio
        { wch: 15 }, // Código Zona SAP
        { wch: 30 }, // Barrio
        { wch: 15 }, // Código Producto
        { wch: 50 }, // Nombre Producto
        { wch: 10 }, // Cantidad
        { wch: 12 }, // Cubicaje Total
        { wch: 20 }, // Tipo de Orden
        { wch: 15 }, // Polígono
        { wch: 15 }  // Fecha Picking
      ];
      worksheet['!cols'] = columnWidths;

      // Crear un libro de trabajo
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Detalle Órdenes');
      
      // Generar el archivo XLSX
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      
      // Crear un Blob con los datos
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      // Crear URL para el blob
      const url = window.URL.createObjectURL(blob);
      
      // Crear elemento para descargar
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `detalle_ordenes_poligono_${id_poligono}_${this.formatearFecha(new Date())}.xlsx`);
      document.body.appendChild(link);
      
      // Descargar archivo
      link.click();
      
      // Limpiar
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      // Mostrar resumen en consola para debugging
      const resumen = this.generarResumenOrdenes(datos);
      console.log('Resumen de órdenes exportadas:', resumen);
      
      this.helpers.notifications.successMessage(`Detalle de órdenes del polígono ${id_poligono} descargado correctamente (${datos.length} registros)`);
    }).catch(error => {
      console.error('Error al generar Excel:', error);
      this.helpers.notifications.errorMessage('Error al generar el archivo Excel');
      
      // Fallback a CSV si hay error
      this.generarCSV(datos, id_poligono);
    });
  }
  
  // Método de respaldo para generar CSV
  generarCSV(datos: DetalleOrden[], id_poligono: string): void {
    // Transformar los datos para mejorar la presentación
    const datosTransformados = this.transformarDatosOrden(datos);
    
    // Convertir datos a formato CSV
    let csvContent = 'data:text/csv;charset=utf-8,\uFEFF'; // BOM para UTF-8
    
    // Encabezados
    const encabezados = Object.keys(datosTransformados[0]);
    csvContent += encabezados.join(',') + '\r\n';
    
    // Filas de datos
    datosTransformados.forEach(row => {
      const values = encabezados.map(header => {
        const value = row[header];
        return typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value;
      });
      csvContent += values.join(',') + '\r\n';
    });
    
    // Crear elemento para descargar
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `detalle_ordenes_poligono_${id_poligono}_${this.formatearFecha(new Date())}.csv`);
    document.body.appendChild(link);
    
    // Descargar archivo
    link.click();
    document.body.removeChild(link);
    
    this.helpers.notifications.successMessage(`Detalle de órdenes del polígono ${id_poligono} descargado en formato CSV (${datos.length} registros)`);
  }

  toggleVistaMensual(event: any): void {
    this.vistaMensual = event.checked;
    console.log('Vista mensual:', this.vistaMensual);
    if (this.vistaMensual && this.cod_bodega) {
      this.cargarDatosMensuales();
    }
  }

  async cargarDatosMensuales(): Promise<void> {
    try {
      if (!this.cod_bodega) {
        this.helpers.notifications.errorMessage("Debe seleccionar una bodega");
        return;
      }
      
      showSpinner();
      const res = await this.logisticaService.obtener_capacidades_poligono_mes_actual('JA', this.cod_bodega);
      
      if (res.success && res.data && res.data.length > 0) {
        this.procesarDatosMensuales(res.data);
        this.helpers.notifications.successMessage("Datos del mes actual cargados correctamente");
      } else {
        this.helpers.notifications.infoMessage("No se encontraron datos para el mes actual");
        this.poligonosMensuales = [];
        this.fechasDelMes = [];
      }
    } catch (error) {
      console.error('Error al cargar datos mensuales:', error);
      this.helpers.notifications.errorMessage("Error al obtener datos del mes actual");
    } finally {
      hideSpinner();
    }
  }

  procesarDatosMensuales(data: any[]): void {
    this.poligonosMensuales = [];
    this.fechasDelMes = [];
    
    // Obtener fechas únicas y ordenarlas
    const fechasUnicas = [...new Set(data.map(item => item.FECHA_PICKING))];
    this.fechasDelMes = fechasUnicas.map(fecha => new Date(fecha)).sort((a, b) => a.getTime() - b.getTime());
    
    // Obtener nombres únicos de polígonos en orden alfabético (determina el orden de columnas)
    this.nombresPoligonos = [...new Set(data.map(item => item.NOMBRE_POLIGONO))]
      .sort((a: string, b: string) => a.localeCompare(b, 'es', { sensitivity: 'base' }));
    
    // Procesar cada registro de la API
    data.forEach(item => {
      const poly: Poligono = {
        id: item.POLIGONO?.toString() || '',
        codigo: item.COD_POLIGONO || '',
        descripcion: item.NOMBRE_POLIGONO || '',
        cubicajeAct: item.CUBICAJE_OCUPADO || 0,
        ordenesAct: item.CANT_ORDENES_OCUPADO || 0,
        cubicajeMax: item.CUBICAJE_TOTAL || 0,
        ordenesMax: item.CANTIDAD_ORD_TOTAL || 0,
        estado: this.determinarEstado(item.ESTADO_DIA),
        cierre_automatico: (item.CIERRE_AUTOMATICO === 'S' ? 'abierto' : 'cerrado') as 'abierto' | 'cerrado',
        fecha: new Date(item.FECHA_PICKING)
      };
      this.poligonosMensuales.push(poly);
    });
    
    console.log(`Datos mensuales procesados para ${this.cod_bodega}:`, this.poligonosMensuales.length, 'registros');
  }

  generarDatosMensuales(): void {
    if (!this.cod_bodega) {
      this.poligonosMensuales = [];
      this.fechasDelMes = [];
      return;
    }
    
    const fechaActual = new Date();
    const diasDelMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0).getDate();
    
    this.poligonosMensuales = [];
    this.fechasDelMes = [];
    
    // Generar fechas del mes
    for (let dia = 1; dia <= diasDelMes; dia++) {
      const fecha = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), dia);
      this.fechasDelMes.push(fecha);
      
      const esDiaFuturo = fecha > fechaActual;
      const esDiaActual = fecha.toDateString() === fechaActual.toDateString();
      
      // Generar datos para cada polígono por día
      this.nombresPoligonos.forEach((nombre, index) => {
        const poly = {
          id: `POL${index + 1}_${dia}`,
          codigo: `POL${index + 1}`,
          descripcion: nombre,
          cubicajeMax: 800 + (index * 100),
          ordenesMax: 30 + (index * 10),
          cubicajeAct: Math.floor(Math.random() * (700 + index * 100)) + 50,
          ordenesAct: Math.floor(Math.random() * (25 + index * 10)) + 5,
          estado: esDiaFuturo ? 'abierto' : (esDiaActual ? (Math.random() > 0.5 ? 'abierto' : 'cerrado') : 'cerrado') as 'abierto' | 'cerrado',
          cierre_automatico: esDiaFuturo ? 'abierto' : (esDiaActual ? (Math.random() > 0.5 ? 'abierto' : 'cerrado') : 'cerrado') as 'abierto' | 'cerrado',
          fecha: fecha
        };
        this.poligonosMensuales.push(poly);
      });
    }
    
    console.log(`Datos mensuales generados para ${this.cod_bodega}:`, this.poligonosMensuales.length, 'registros');
  }

  getPoligonoByFechaYNombre(fecha: Date, nombre: string): Poligono | null {
    return this.poligonosMensuales.find(p => 
      p.fecha?.toDateString() === fecha.toDateString() && p.descripcion === nombre
    ) || null;
  }

  async descargarReporteMensual(): Promise<void> {
    try {
      if (!this.cod_bodega) {
        this.helpers.notifications.errorMessage("Debe seleccionar una bodega");
        return;
      }
      
      showSpinner();
      const res = await this.logisticaService.detalle_ordenes_mes_actual('JA', this.cod_bodega);
      console.log('Respuesta reporte mensual:', res);
      
      if (res.success && res.data && res.data.length > 0) {
        this.generarExcelMensual(res.data);
      } else {
        this.helpers.notifications.infoMessage("No se encontraron órdenes para el mes actual");
      }
    } catch (error) {
      console.error('Error al descargar reporte mensual:', error);
      this.helpers.notifications.errorMessage("Error al obtener el reporte mensual");
    } finally {
      hideSpinner();
    }
  }

  async obtenerDetalleFechaPickind(): Promise<void> {
    try {
      if (!this.cod_bodega) {
        this.helpers.notifications.errorMessage("Debe seleccionar una bodega");
        return;
      }
      
      showSpinner();
      const fechaFormateada = this.fechaSeleccionada ? 
        this.formatearFecha(this.fechaSeleccionada) : 
        this.formatearFecha(new Date());
      const res = await this.logisticaService.detalle_ordenesFechaPicking(this.cod_bodega, 'JA', fechaFormateada);
      console.log('Respuesta detalle por fecha picking:', res);
      
      if (res.success && res.data && res.data.length > 0) {
        this.generarExcelFechaPicking(res.data, fechaFormateada);
      } else {
        this.helpers.notifications.infoMessage(`No se encontraron órdenes para la fecha ${fechaFormateada}`);
      }
    } catch (error) {
      console.error('Error al obtener detalle por fecha picking:', error);
      this.helpers.notifications.errorMessage("Error al obtener detalle de órdenes por fecha");
    } finally {
      hideSpinner();
    }
  }

  generarExcelFechaPicking(datos: DetalleOrden[], fechaFormateada: string): void {
    import('xlsx').then(XLSX => {
      // Transformar los datos para mejorar la presentación
      const datosTransformados = this.transformarDatosOrden(datos);
      
      const worksheet = XLSX.utils.json_to_sheet(datosTransformados);
      
      // Ajustar el ancho de las columnas
      const columnWidths = [
        { wch: 20 }, // Número de Orden
        { wch: 15 }, // Pedido SAP
        { wch: 20 }, // Departamento
        { wch: 20 }, // Municipio
        { wch: 15 }, // Código Zona SAP
        { wch: 30 }, // Barrio
        { wch: 15 }, // Código Producto
        { wch: 50 }, // Nombre Producto
        { wch: 10 }, // Cantidad
        { wch: 12 }, // Cubicaje Total
        { wch: 20 }, // Tipo de Orden
        { wch: 15 }, // Polígono
        { wch: 15 }  // Fecha Picking
      ];
      worksheet['!cols'] = columnWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Detalle por Fecha');
      
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `detalle_ordenes_fecha_${fechaFormateada}_bodega_${this.cod_bodega}.xlsx`);
      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      // Mostrar resumen en consola para debugging
      const resumen = this.generarResumenOrdenes(datos);
      console.log('Resumen de órdenes por fecha exportadas:', resumen);
      
      this.helpers.notifications.successMessage(`Detalle de órdenes para la fecha ${fechaFormateada} descargado correctamente (${datos.length} registros)`);
    }).catch(error => {
      console.error('Error al generar Excel por fecha:', error);
      this.helpers.notifications.errorMessage('Error al generar el archivo Excel');
    });
  }

  generarExcelMensual(datos: DetalleOrden[]): void {
    import('xlsx').then(XLSX => {
      // Transformar los datos para mejorar la presentación
      const datosTransformados = this.transformarDatosOrden(datos);
      
      const worksheet = XLSX.utils.json_to_sheet(datosTransformados);
      
      // Ajustar el ancho de las columnas
      const columnWidths = [
        { wch: 20 }, // Número de Orden
        { wch: 15 }, // Pedido SAP
        { wch: 20 }, // Departamento
        { wch: 20 }, // Municipio
        { wch: 15 }, // Código Zona SAP
        { wch: 30 }, // Barrio
        { wch: 15 }, // Código Producto
        { wch: 50 }, // Nombre Producto
        { wch: 10 }, // Cantidad
        { wch: 12 }, // Cubicaje Total
        { wch: 20 }, // Tipo de Orden
        { wch: 15 }, // Polígono
        { wch: 15 }  // Fecha Picking
      ];
      worksheet['!cols'] = columnWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte Mensual');
      
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `reporte_mensual_ordenes_bodega_${this.cod_bodega}_${this.formatearFecha(new Date())}.xlsx`);
      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      // Mostrar resumen en consola para debugging
      const resumen = this.generarResumenOrdenes(datos);
      console.log('Resumen de reporte mensual exportado:', resumen);
      
      this.helpers.notifications.successMessage(`Reporte mensual de órdenes de la bodega ${this.cod_bodega} descargado correctamente (${datos.length} registros)`);
    }).catch(error => {
      console.error('Error al generar Excel mensual:', error);
      this.helpers.notifications.errorMessage('Error al generar el archivo Excel');
    });
  }

  private modalAbierto = false;
  private modalPolyId = '';
  private modalCodBodega = '';
  private modalFecha = '';
  // Identificador único por apertura del modal: evita que querySelectorAll
  // (que busca en todo el documento) confunda los toggles de esta apertura
  // con los de un diálogo anterior que haya quedado en el DOM (p. ej. por la
  // animación de cierre de Angular Material), lo que causaría que un clic en
  // un toggle "aterrice" sobre el nodo de otra apertura.
  private modalInstanceId = '';
  private svcToggleListeners: Array<{ el: Element; fn: EventListener }> = [];

  async abrirModalDetalle(poly: Poligono): Promise<void> {
    if (this.modalAbierto) return;
    this.modalAbierto = true;
    // Defensivo: si un cierre anterior no alcanzó a limpiar sus listeners
    // (p. ej. animación de cierre de Angular Material aún en curso), no
    // arrastrarlos a esta apertura — cada apertura vuelve a adjuntar los suyos.
    this.svcToggleListeners = [];

    showSpinner();

    try {
      const cubicajePorcentaje = this.getPorcentajeNum(poly.cubicajeAct, poly.cubicajeMax);
      const ordenesPorcentaje = this.getPorcentajeNum(poly.ordenesAct, poly.ordenesMax);
      const cubicajeClass = this.getAlertaClass(cubicajePorcentaje);
      const ordenesClass = this.getAlertaClass(ordenesPorcentaje);
      const estadoClass = poly.estado === 'abierto' ? 'estado-abierto' : 'estado-cerrado';

      let detalleGeografico = '';

      // En vista mensual usar la fecha del polígono, en vista normal usar la fecha seleccionada
      const fechaFormateada = this.vistaMensual && poly.fecha ?
        this.formatearFecha(poly.fecha) :
        (this.fechaSeleccionada ? this.formatearFecha(this.fechaSeleccionada) : this.formatearFecha(new Date()));

      // Guardar contexto para los listeners del toggle de servicios
      this.modalPolyId     = poly.id;
      this.modalCodBodega  = this.cod_bodega;
      this.modalFecha      = fechaFormateada;
      this.modalInstanceId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;

      const [res, estadoSvcRes] = await Promise.all([
        this.logisticaService.detalle_llenado_departamento_municipio('JA', this.cod_bodega, fechaFormateada, poly.id),
        this.logisticaService.consultar_estado_servicios('JA', poly.id, this.cod_bodega, fechaFormateada)
      ]);

      const estadoServicios: string = estadoSvcRes.success
        ? (estadoSvcRes.data?.ESTADO_SERVICIOS || 'ABIERTO')
        : 'ABIERTO';
      const desgloseTipoServicio: any = estadoSvcRes.success
        ? (estadoSvcRes.data?.DESGLOSE_TIPO_SERVICIO || {})
        : {};

      let seccionTipoOrden = '';
      if (res.success && res.data && res.data.length > 0) {
        detalleGeografico = this.generarDetalleGeografico(res.data, poly.cubicajeMax, poly.ordenesMax);
        seccionTipoOrden  = this.generarSeccionTipoOrden(res.data, estadoServicios, desgloseTipoServicio);
      } else {
        detalleGeografico = this.generarSeccionVacia();
      }

      const detalleHtml = `
        <div class="modal-detalle-moderno" data-modal-instance="${this.modalInstanceId}">
          <div class="modal-header">
            <div class="header-content">
              <h2 class="modal-title">${poly.descripcion}</h2>
              <div class="estado-badge ${poly.estado}">${poly.estado === 'abierto' ? 'Abierto' : 'Cerrado'}</div>
            </div>
            <div class="codigo-info">Código: ${poly.codigo}</div>
          </div>
          
          <div class="modal-body">
            <div class="info-general">
              <h3 class="seccion-titulo">📊 Información General</h3>
              <div class="info-grid">
                <div class="info-item">
                  <span class="info-label">Código:</span>
                  <span class="info-value">${poly.codigo}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Estado:</span>
                  <span class="info-value ${estadoClass}">${poly.estado === 'abierto' ? 'Abierto' : 'Cerrado'}</span>
                </div>
              </div>
            </div>
            
            <div class="metricas-principales">
              <div class="metrica-card">
                <div class="metrica-header">
                  <span class="metrica-icon">📦</span>
                  <span class="metrica-titulo">Cubicaje</span>
                </div>
                <div class="metrica-detalle">
                  <div class="detalle-item">
                    <span class="detalle-label">Actual:</span>
                    <span class="detalle-value">${poly.cubicajeAct.toFixed(2)}</span>
                  </div>
                  <div class="detalle-item">
                    <span class="detalle-label">Máximo:</span>
                    <span class="detalle-value">${poly.cubicajeMax}</span>
                  </div>
                  <div class="detalle-item">
                    <span class="detalle-label">Porcentaje:</span>
                    <span class="detalle-value">${this.getPorcentaje(poly.cubicajeAct, poly.cubicajeMax)}%</span>
                  </div>
                </div>
                <div class="progress-container">
                  <div class="progress-bar ${cubicajeClass}" style="width: ${cubicajePorcentaje}%">
                    <span class="progress-text">Cubicaje ${this.getPorcentaje(poly.cubicajeAct, poly.cubicajeMax)}%</span>
                  </div>
                </div>
              </div>
              
              <div class="metrica-card">
                <div class="metrica-header">
                  <span class="metrica-icon">📋</span>
                  <span class="metrica-titulo">Órdenes</span>
                </div>
                <div class="metrica-detalle">
                  <div class="detalle-item">
                    <span class="detalle-label">Actual:</span>
                    <span class="detalle-value">${poly.ordenesAct}</span>
                  </div>
                  <div class="detalle-item">
                    <span class="detalle-label">Máximo:</span>
                    <span class="detalle-value">${poly.ordenesMax}</span>
                  </div>
                  <div class="detalle-item">
                    <span class="detalle-label">Porcentaje:</span>
                    <span class="detalle-value">${this.getPorcentaje(poly.ordenesAct, poly.ordenesMax)}%</span>
                  </div>
                </div>
                <div class="progress-container">
                  <div class="progress-bar ${ordenesClass}" style="width: ${ordenesPorcentaje}%">
                    <span class="progress-text">Órdenes ${this.getPorcentaje(poly.ordenesAct, poly.ordenesMax)}%</span>
                  </div>
                </div>
              </div>
            </div>
            
            ${seccionTipoOrden}
            ${detalleGeografico}
          </div>
        </div>
      `;
      
      hideSpinner();
      
      // El [innerHTML] del diálogo sanitiza el HTML por defecto, lo que
      // elimina atributos data-* (data-tipo-servicio, data-modal-instance,
      // etc.) de los que dependen los toggles de servicio. bypassSecurityTrustHtml
      // es seguro aquí porque detalleHtml es generado enteramente por este
      // componente, no contiene entrada de usuario.
      const dialogRef = this.dialog.open(CokyHelperDialogComponent, {
        data: {
          type: 'INFO',
          title: '',
          text: this.sanitizer.bypassSecurityTrustHtml(detalleHtml),
          button: null
        },
        width: '800px',
        height: 'auto',
        maxHeight: '90vh'
      });

      dialogRef.afterOpened().subscribe(() => {
        setTimeout(() => {
          const contenedor = this.getModalContainerActual();
          if (!contenedor) return;
          const toggles = contenedor.querySelectorAll('.svc-toggle:not(.svc-toggle-disabled)');
          toggles.forEach((el: Element) => {
            const fn: EventListener = () => this.onSvcToggleClick(el as HTMLElement);
            el.addEventListener('click', fn);
            this.svcToggleListeners.push({ el, fn });
          });
        }, 150);
      });

      dialogRef.afterClosed().subscribe(() => {
        this.modalAbierto = false;
        this.svcToggleListeners.forEach(({ el, fn }) => el.removeEventListener('click', fn));
        this.svcToggleListeners = [];
      });
      
    } catch (error) {
      hideSpinner();
      this.modalAbierto = false;
      console.error('Error al abrir modal:', error);
      this.helpers.notifications.errorMessage('Error al cargar los detalles del polígono');
    }
  }

  private generarSeccionTipoOrden(data: any[], estadoServicios: string = 'ABIERTO', desgloseTipoServicio: any = {}): string {
    const tiposMap = new Map<string, { ordenes: number; cubicaje: number }>();
    data.forEach(item => {
      const tipo = item.TIPO_ORDEN || 'SIN_TIPO';
      if (!tiposMap.has(tipo)) tiposMap.set(tipo, { ordenes: 0, cubicaje: 0 });
      const e = tiposMap.get(tipo)!;
      e.ordenes  += Number(item.CANT_ORDENES)      || 0;
      e.cubicaje += Number(item.SUM_CUBICAJE_TOTAL) || 0;
    });

    if (tiposMap.size === 0) return '';

    const totalOrdenes = Array.from(tiposMap.values()).reduce((s, v) => s + v.ordenes, 0);
    const maxOrdenes   = Math.max(...Array.from(tiposMap.values()).map(v => v.ordenes), 1);

    const tipoLabels: {[k: string]: string} = {
      'OP_NORMAL':           'OP Normal',
      'OP_PARCIAL':          'OP Parcial',
      'CROSSDOCKING':        'CrossDocking',
      'SERVICIO_NORMAL':     'Servicio Normal',
      'SERVICIO_SALESFORCE': 'Servicio Salesforce',
    };
    const tipoClases: {[k: string]: string} = {
      'OP_NORMAL':           'tc-op-normal',
      'OP_PARCIAL':          'tc-op-parcial',
      'CROSSDOCKING':        'tc-crossdocking',
      'SERVICIO_NORMAL':     'tc-svc-normal',
      'SERVICIO_SALESFORCE': 'tc-svc-salesforce',
    };

    const esServicio = (tipo: string) =>
      tipo === 'SERVICIO_NORMAL' || tipo === 'SERVICIO_SALESFORCE';

    const estadoToggle = estadoServicios === 'CERRADO' ? 'cerrado' : 'abierto';
    // "Todos: " deja explícito que este toggle actúa sobre los 5 tipos de
    // servicio a la vez, para no confundirlo con los toggles por tipo de
    // abajo (que solo dicen "Abierto"/"Cerrado").
    const textoToggle  = estadoServicios === 'CERRADO' ? 'Todos: Cerrado' : 'Todos: Abierto';
    const iconoToggle  = estadoServicios === 'CERRADO' ? '🔒' : '🔓';

    const tiposNormales: Array<[string, { ordenes: number; cubicaje: number }]> = [];
    const tiposServicio: Array<[string, { ordenes: number; cubicaje: number }]> = [];
    tiposMap.forEach((v, tipo) => {
      if (esServicio(tipo)) tiposServicio.push([tipo, v]);
      else tiposNormales.push([tipo, v]);
    });

    const renderRow = (tipo: string, v: { ordenes: number; cubicaje: number }, compact = false): string => {
      const pct      = totalOrdenes > 0 ? ((v.ordenes / totalOrdenes) * 100).toFixed(1) : '0.0';
      const barWidth = Math.round((v.ordenes / maxOrdenes) * 100);
      const clase    = tipoClases[tipo] || 'tc-default';
      const label    = tipoLabels[tipo] || tipo.replace(/_/g, ' ');
      return `
        <div class="tipo-row${compact ? ' tipo-row-compact' : ''}">
          <div class="tipo-header-row">
            <span class="tipo-nombre">
              <span class="tipo-dot ${clase}"></span>
              ${label}
            </span>
            <span class="tipo-stats">
              <strong>${v.ordenes}</strong> órdenes &nbsp;·&nbsp;
              ${v.cubicaje.toFixed(2)} m³ &nbsp;·&nbsp;
              <strong>${pct}%</strong>
            </span>
          </div>
          <div class="tipo-bar-track">
            <div class="tipo-bar-fill ${clase}" style="width:${barWidth}%">
              <span class="tipo-bar-label">${pct}%</span>
            </div>
          </div>
        </div>`;
    };

    let html = `
      <div class="tipo-orden-seccion">
        <h3 class="seccion-titulo">📊 Distribución por Tipo de Orden</h3>
        <div class="tipo-orden-total-badge">${totalOrdenes} órdenes en total</div>
        <div class="tipo-orden-lista">
    `;

    tiposNormales.forEach(([tipo, v]) => { html += renderRow(tipo, v); });

    if (tiposServicio.length > 0) {
      // Calcular totales del encabezado desde el desglose (misma fuente que las filas internas)
      const tiposSvc: Array<'CAM' | 'CAP' | 'TAR' | 'TAE' | 'DEV' | 'NTC'> = ['CAM', 'CAP', 'TAR', 'TAE', 'DEV', 'NTC'];
      const svcOrdenesDesglose  = tiposSvc.reduce((s, t) => s + (Number(desgloseTipoServicio?.[t]?.CANTIDAD_ORDENES) || 0), 0);
      const svcCubicajeDesglose = tiposSvc.reduce((s, t) => s + (Number(desgloseTipoServicio?.[t]?.CUBICAJE) || 0), 0);
      const svcPct = totalOrdenes > 0 ? ((svcOrdenesDesglose / totalOrdenes) * 100).toFixed(1) : '0.0';

      // Sin ninguna orden de servicio ese día, el toggle combinado tampoco tiene nada que gestionar.
      const sinDatosGrupo = svcOrdenesDesglose === 0;
      const toggleGrupoDisabledClass = sinDatosGrupo ? ' svc-toggle-disabled' : '';
      const toggleGrupoTitle = sinDatosGrupo
        ? 'No hay órdenes de servicios para gestionar en esta fecha'
        : `${estadoServicios === 'CERRADO' ? 'Abrir' : 'Cerrar'} TODOS los tipos de servicio a la vez (cambio total, parcial, taller y devoluciones). Para cerrar solo uno, usa su toggle individual abajo.`;

      html += `
        <div class="svc-group-box">
          <div class="svc-group-header">
            <div class="svc-group-title">
              <span class="svc-group-icon">🔄</span>
              Servicios
              <span class="svc-group-badge">${svcOrdenesDesglose} órd · ${svcCubicajeDesglose.toFixed(2)} m³ · ${svcPct}%</span>
            </div>
            <span class="svc-toggle svc-toggle-combinado ${estadoToggle}${toggleGrupoDisabledClass}" data-tipo="SERVICIOS" title="${toggleGrupoTitle}">
              <span class="svc-pill"><span class="svc-dot"></span></span>
              <span class="svc-txt">${iconoToggle} ${textoToggle}</span>
            </span>
          </div>
          <div class="svc-group-rows">
      `;
      html += this.renderFilasTipoServicio(desgloseTipoServicio);
      html += `</div></div>`;
    }

    html += '</div></div>';
    return html;
  }

  // Filas del bloque "Servicios" por tipo real (Cambio Total / Cambio Parcial /
  // Taller Recogida / Taller Entrega) en vez de por origen (Servicio Normal /
  // Servicio Salesforce): cada uno con su propio toggle de apertura/cierre
  // independiente, criterio de aceptación 2. Se muestran los 5 tipos siempre
  // (aunque estén en 0) para que quede claro qué hay y qué no ese día.
  private renderFilasTipoServicio(desglose: any): string {
    const tipos: Array<'CAM' | 'CAP' | 'TAR' | 'TAE' | 'DEV' | 'NTC'> = ['CAM', 'CAP', 'TAR', 'TAE', 'DEV', 'NTC'];
    const cantidades = tipos.map(tipo => Number(desglose?.[tipo]?.CANTIDAD_ORDENES) || 0);
    const svcTotal   = cantidades.reduce((s, c) => s + c, 0);

    let html = '';
    tipos.forEach(tipo => {
      const datos     = desglose?.[tipo] || {};
      // El estado es durable (por defecto Abierto si nadie lo cerró explícitamente)
      // y no depende de si ya hay citas generadas ese día en el calendario.
      const cerrado   = datos.ESTADO_SERVICIOS === 'CERRADO';
      const estado    = cerrado ? 'cerrado' : 'abierto';
      const texto     = cerrado ? 'Cerrado' : 'Abierto';
      const icono     = cerrado ? '🔒' : '🔓';
      const label     = this.TIPO_SOL_LABELS[tipo] || tipo;
      const clase     = this.TIPO_SOL_CLASES[tipo] || 'tc-default';
      const cantidad  = Number(datos.CANTIDAD_ORDENES) || 0;
      const cubicaje  = Number(datos.CUBICAJE)         || 0;
      const pct       = svcTotal > 0 ? ((cantidad / svcTotal) * 100).toFixed(1) : '0.0';
      // La barra representa el mismo porcentaje que se muestra en la etiqueta
      // (antes se escalaba contra el máximo del grupo, lo que la desalineaba
      // del "X.X%" mostrado al lado).
      const barWidth  = Math.min(100, Number(pct));

      // Sin órdenes de este tipo no hay nada que abrir/cerrar: el toggle queda inerte.
      const sinDatos  = cantidad === 0;
      const toggleDisabledClass = sinDatos ? ' svc-toggle-disabled' : '';
      const toggleTitle = sinDatos
        ? `No hay órdenes de ${label.toLowerCase()} para gestionar en esta fecha`
        : `${cerrado ? 'Abrir' : 'Cerrar'} ${label.toLowerCase()} para el polígono en esta fecha`;

      html += `
        <div class="tipo-row tipo-row-compact svc-tipo-sol-row">
          <div class="tipo-header-row">
            <span class="tipo-nombre">
              <span class="tipo-dot ${clase}"></span>
              ${label}
            </span>
            <span class="tipo-stats">
              <strong>${cantidad}</strong> ord. / ${cubicaje.toFixed(2)} m³ &nbsp;·&nbsp;
              <strong>${pct}%</strong>
            </span>
            <span class="svc-toggle svc-toggle-tipo ${estado}${toggleDisabledClass}" data-tipo-servicio="${tipo}" title="${toggleTitle}">
              <span class="svc-pill"><span class="svc-dot"></span></span>
              <span class="svc-txt">${icono} ${texto}</span>
            </span>
          </div>
          <div class="tipo-bar-track">
            <div class="tipo-bar-fill ${clase}" style="width:${barWidth}%">
              <span class="tipo-bar-label">${pct}%</span>
            </div>
          </div>
        </div>`;
    });

    return html;
  }

  // Único punto de acceso al contenedor del modal ACTUALMENTE abierto, por su
  // data-modal-instance. Evita que document.querySelectorAll (que busca en
  // todo el documento) recoja nodos de una apertura anterior del mismo modal
  // que hayan quedado en el DOM.
  private getModalContainerActual(): Element | null {
    return document.querySelector(`.modal-detalle-moderno[data-modal-instance="${this.modalInstanceId}"]`);
  }

  private onSvcToggleClick(el: HTMLElement): void {
    if (el.classList.contains('svc-toggle-disabled')) return;
    const tipoServicio = el.getAttribute('data-tipo-servicio') as ('CAM' | 'CAP' | 'TAR' | 'TAE' | 'DEV' | 'NTC' | null);
    const estaAbierto  = el.classList.contains('abierto');
    const accion: 'CERRAR' | 'ABRIR' = estaAbierto ? 'CERRAR' : 'ABRIR';
    const usuario = getCurrentUser()?.usuario_aplicativo || '';
    const label = tipoServicio ? this.TIPO_SOL_LABELS[tipoServicio] : null;

    const titulo   = tipoServicio ? `Confirmar cierre de ${label}` : 'Confirmar cierre de TODOS los servicios';
    const mensaje  = tipoServicio
      ? `¿Está seguro que desea cerrar el servicio de <strong>${label}</strong> para el polígono en la fecha ${this.modalFecha}? Esto no afecta a los demás tipos de servicio.`
      : `¿Está seguro que desea cerrar <strong>los 5 tipos de servicio juntos</strong> (cambio total, parcial, taller y devoluciones) para el polígono en la fecha ${this.modalFecha}?<br/><br/>Si solo quieres cerrar un tipo específico, cierra este diálogo y usa su toggle individual en la lista de abajo.`;

    if (estaAbierto) {
      this.helpers.notifications.warningDialog(
        titulo,
        mensaje,
        'Aceptar',
        () => this.ejecutarToggleServicio(accion, usuario, el, tipoServicio || undefined),
        '450px'
      );
    } else {
      this.ejecutarToggleServicio(accion, usuario, el, tipoServicio || undefined);
    }
  }

  private async ejecutarToggleServicio(
    accion: 'CERRAR' | 'ABRIR',
    usuario: string,
    elClicked: HTMLElement,
    tipoServicio?: 'CAM' | 'CAP' | 'TAR' | 'TAE' | 'DEV' | 'NTC'
  ): Promise<void> {
    try {
      showSpinner();
      const res = await this.logisticaService.cerrar_servicios_poligono(
        'JA', this.modalPolyId, this.modalCodBodega, this.modalFecha, usuario, accion, tipoServicio
      );
      if (res.success) {
        const aplicarEstado = (t: Element, abierto: boolean, esCombinado = false) => {
          t.classList.remove('abierto', 'cerrado');
          t.classList.add(abierto ? 'abierto' : 'cerrado');
          const txt = t.querySelector('.svc-txt');
          const icono = abierto ? '🔓' : '🔒';
          if (txt) txt.textContent = esCombinado
            ? `${icono} Todos: ${abierto ? 'Abierto' : 'Cerrado'}`
            : `${icono} ${abierto ? 'Abierto' : 'Cerrado'}`;
        };
        const nuevoAbierto = accion === 'ABRIR';
        const contenedor = this.getModalContainerActual();

        if (!tipoServicio) {
          // Toggle combinado: cierra/abre en cascada los 3 sub-toggles (igual que el backend).
          aplicarEstado(elClicked, nuevoAbierto, true);
          contenedor?.querySelectorAll('.svc-toggle-tipo')
            .forEach(t => aplicarEstado(t, nuevoAbierto));
        } else {
          aplicarEstado(elClicked, nuevoAbierto);
          // El toggle combinado queda "abierto" si algún tipo sigue abierto, "cerrado" solo si los 3 lo están.
          const subToggles = contenedor?.querySelectorAll('.svc-toggle-tipo') || [];
          const algunoAbierto = Array.from(subToggles).some(t => t.classList.contains('abierto'));
          const combinado = contenedor?.querySelector('.svc-toggle-combinado');
          if (combinado) aplicarEstado(combinado, algunoAbierto, true);
        }

        const sujeto = tipoServicio ? this.TIPO_SOL_LABELS[tipoServicio] : 'Servicios';
        this.helpers.notifications.successMessage(res.message || `${sujeto} ${accion === 'CERRAR' ? 'cerrado(s)' : 'abierto(s)'} correctamente.`);
      } else {
        this.helpers.notifications.errorMessage(res.message || 'Error al gestionar los servicios.');
      }
    } catch (error) {
      console.error('Error al gestionar servicios:', error);
      this.helpers.notifications.errorMessage('Error al gestionar los servicios.');
    } finally {
      hideSpinner();
    }
  }

  // ---------------------------------------------------------------------
  // Cierre / Apertura Masiva de Servicios por Día de Picking
  // Historia: "Cierre masivo de servicios por día de picking en Cubica+"
  // A diferencia de ejecutarToggleServicio (cierre por polígono, dentro del
  // modal de detalle), esta acción cierra o abre de una sola vez todos los
  // servicios elegibles de la bodega/fecha seleccionadas en el tablero.
  // Solo tiene sentido en la vista normal (un día concreto); en vista
  // mensual el botón no aplica (ver *ngIf="!vistaMensual" en el HTML).
  // ---------------------------------------------------------------------

  async onGestionarServiciosDiaClick(): Promise<void> {
    if (!this.cod_bodega || !this.fechaSeleccionada) {
      this.helpers.notifications.errorMessage('Debe seleccionar una bodega y una fecha para gestionar los servicios del día.');
      return;
    }

    const fechaFormateada = this.formatearFecha(this.fechaSeleccionada);

    try {
      showSpinner();
      const consulta = await this.logisticaService.consultar_servicios_dia_picking('JA', this.cod_bodega, fechaFormateada);

      if (!consulta.success) {
        this.helpers.notifications.errorMessage(consulta.message || 'Error al consultar los servicios del día de picking.');
        return;
      }

      const total             = consulta.data?.total_servicios || 0;
      const elegiblesCierre   = consulta.data?.servicios_elegibles_cierre || 0;
      const elegiblesApertura = consulta.data?.servicios_elegibles_apertura || 0;

      if (total === 0) {
        this.helpers.notifications.infoMessage(`No hay servicios registrados para la bodega ${this.cod_bodega} en la fecha ${fechaFormateada}.`);
        return;
      }

      const detallePorPoligono = (consulta.data?.detalle_por_poligono || []) as Array<{
        id_poligono: number; cod_poligono?: string; nombre_poligono?: string;
        total_servicios: number; desglose_tipo_servicio?: any;
      }>;
      const desglosePorTipo = this.agregarDesglosePorTipoDia(detallePorPoligono);

      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        codigoBodega: this.cod_bodega,
        fechaPicking: fechaFormateada,
        totalServicios: total,
        elegiblesCierre,
        elegiblesApertura,
        desglosePorTipo,
        detallePorPoligono: this.mapearDetallePorPoligono(detallePorPoligono),
      };
      dialogConfig.width = '460px';
      dialogConfig.autoFocus = false;

      const dialogRef = this.dialog.open(ModalGestionarServiciosDiaComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((resultado?: GestionarServiciosDiaResultado) => {
        if (!resultado) return;
        const cantidad = resultado.tipoServicio
          ? (desglosePorTipo.find(d => d.tipo === resultado.tipoServicio)?.[resultado.accion === 'CERRAR' ? 'poligonosAbiertos' : 'poligonosCerrados'] || 0)
          : (resultado.accion === 'CERRAR' ? elegiblesCierre : elegiblesApertura);
        this.confirmarAccionMasivaServicios(resultado.accion, fechaFormateada, cantidad, resultado.tipoServicio);
      });
    } catch (error) {
      console.error('Error al consultar servicios del día de picking:', error);
      this.helpers.notifications.errorMessage('Error al consultar los servicios del día de picking.');
    } finally {
      hideSpinner();
    }
  }

  // Mapea el detalle crudo de consultar_servicios_dia_picking a la forma que
  // espera el modal, para visualizar cuántos hay por tipo en cada polígono.
  private mapearDetallePorPoligono(detallePorPoligono: Array<{
    id_poligono: number; cod_poligono?: string; nombre_poligono?: string;
    total_servicios: number; desglose_tipo_servicio?: any;
  }>): Array<{ id: number; codigo: string | null; nombre: string | null; totalServicios: number; desglose: Array<{ tipo: 'CAM' | 'CAP' | 'TAR' | 'TAE' | 'DEV' | 'NTC'; label: string; cantidadOrdenes: number; cubicaje: number; estado: string }> }> {
    const tipos: Array<'CAM' | 'CAP' | 'TAR' | 'TAE' | 'DEV' | 'NTC'> = ['CAM', 'CAP', 'TAR', 'TAE', 'DEV', 'NTC'];
    return detallePorPoligono
      .filter(p => p.id_poligono != null)
      .map(p => ({
        id: p.id_poligono,
        codigo: p.cod_poligono || null,
        nombre: p.nombre_poligono || null,
        totalServicios: p.total_servicios,
        desglose: tipos
          .map(tipo => {
            const datos = p.desglose_tipo_servicio?.[tipo];
            return {
              tipo,
              label: this.TIPO_SOL_LABELS[tipo] || tipo,
              cantidadOrdenes: Number(datos?.cantidad_ordenes) || 0,
              cubicaje: Number(datos?.cubicaje) || 0,
              estado: datos?.estado_servicios === 'CERRADO' ? 'CERRADO' : 'ABIERTO',
            };
          })
          .filter(d => d.cantidadOrdenes > 0),
      }));
  }

  // Agrega el desglose por polígono (de consultar_servicios_dia_picking) en un
  // resumen por tipo de servicio (CAM/CAP/Taller Recogida/Taller Entrega)
  // para todo el día de picking. El conteo son órdenes reales; el estado
  // (abierto/cerrado) es por polígono, uno de los dos siempre, sin datos "en 0".
  private agregarDesglosePorTipoDia(detallePorPoligono: Array<{ desglose_tipo_servicio?: any }>): Array<{ tipo: 'CAM' | 'CAP' | 'TAR' | 'TAE' | 'DEV' | 'NTC'; label: string; totalOrdenes: number; poligonosAbiertos: number; poligonosCerrados: number }> {
    const tipos: Array<'CAM' | 'CAP' | 'TAR' | 'TAE' | 'DEV' | 'NTC'> = ['CAM', 'CAP', 'TAR', 'TAE', 'DEV', 'NTC'];
    return tipos
      .map(tipo => {
        let totalOrdenes = 0;
        let poligonosAbiertos = 0;
        let poligonosCerrados = 0;
        detallePorPoligono.forEach(p => {
          const datos = p.desglose_tipo_servicio?.[tipo];
          if (!datos) return;
          const cantidad = Number(datos.cantidad_ordenes) || 0;
          if (cantidad === 0) return;
          totalOrdenes += cantidad;
          if (datos.estado_servicios === 'CERRADO') poligonosCerrados++;
          else poligonosAbiertos++;
        });
        return { tipo, label: this.TIPO_SOL_LABELS[tipo] || tipo, totalOrdenes, poligonosAbiertos, poligonosCerrados };
      })
      .filter(d => d.totalOrdenes > 0);
  }

  private confirmarAccionMasivaServicios(accion: 'CERRAR' | 'ABRIR', fechaFormateada: string, cantidad: number, tipoServicio?: 'CAM' | 'CAP' | 'TAR' | 'TAE' | 'DEV' | 'NTC'): void {
    const verbo  = accion === 'CERRAR' ? 'cerrarán' : 'abrirán';
    const sujeto = tipoServicio
      ? `servicio(s) de <strong>${this.TIPO_SOL_LABELS[tipoServicio]}</strong> en <strong>${cantidad}</strong> polígono(s)`
      : `<strong>${cantidad}</strong> servicio(s)`;
    this.helpers.notifications.warningDialog(
      accion === 'CERRAR' ? 'Confirmar cierre masivo de servicios' : 'Confirmar apertura masiva de servicios',
      `Se ${verbo} ${sujeto} de la bodega <strong>${this.cod_bodega}</strong> ` +
      `para el día de picking <strong>${fechaFormateada}</strong>.<br/><br/>` +
      `Esta acción no se puede deshacer. ¿Desea continuar?`,
      accion === 'CERRAR' ? 'Confirmar cierre' : 'Confirmar apertura',
      () => this.ejecutarAccionMasivaServicios(accion, fechaFormateada, tipoServicio),
      '480px'
    );
  }

  private async ejecutarAccionMasivaServicios(accion: 'CERRAR' | 'ABRIR', fechaFormateada: string, tipoServicio?: 'CAM' | 'CAP' | 'TAR' | 'TAE' | 'DEV' | 'NTC'): Promise<void> {
    const usuario = getCurrentUser()?.usuario_aplicativo || '';

    try {
      showSpinner();
      const res = accion === 'CERRAR'
        ? await this.logisticaService.cierre_masivo_servicios_dia('JA', this.cod_bodega, fechaFormateada, usuario, tipoServicio)
        : await this.logisticaService.apertura_masiva_servicios_dia('JA', this.cod_bodega, fechaFormateada, usuario, tipoServicio);

      if (res.success) {
        const procesados   = res.data?.servicios_procesados ?? 0;
        const noProcesados = res.data?.servicios_no_procesados ?? 0;
        const detalle       = (res.data?.detalle_poligonos || []) as Array<{ id_poligono: number; servicios_procesados: number }>;
        const verbo         = accion === 'CERRAR' ? 'cerraron' : 'abrieron';

        let resumenHtml = `Se ${verbo} <strong>${procesados}</strong> servicio(s) correctamente.`;
        if (noProcesados > 0) {
          resumenHtml += `<br/><strong>${noProcesados}</strong> servicio(s) no pudieron procesarse (cambiaron de estado durante el proceso).`;
        }
        if (detalle.length > 0) {
          resumenHtml += '<br/><br/><u>Detalle por polígono:</u><ul>';
          detalle.forEach(d => { resumenHtml += `<li>Polígono ${d.id_poligono}: ${d.servicios_procesados} servicio(s)</li>`; });
          resumenHtml += '</ul>';
        }

        this.helpers.notifications.successDialog(
          accion === 'CERRAR' ? 'Cierre masivo ejecutado' : 'Apertura masiva ejecutada',
          resumenHtml
        );

        // Refrescar el tablero para reflejar los nuevos estados de los polígonos
        this.BuscarCapacidadesTransporte();
      } else {
        this.helpers.notifications.errorMessage(res.message || 'Error al ejecutar la acción masiva sobre los servicios.');
      }
    } catch (error) {
      console.error('Error al ejecutar la acción masiva sobre los servicios:', error);
      this.helpers.notifications.errorMessage('Error al ejecutar la acción masiva sobre los servicios.');
    } finally {
      hideSpinner();
    }
  }

  private generarDetalleGeografico(data: any[], cubicajeMax: number, ordenesMax: number): string {
    const tipoLabels: {[k: string]: string} = {
      'OP_NORMAL':           'OP Normal',
      'OP_PARCIAL':          'OP Parcial',
      'CROSSDOCKING':        'CrossDocking',
      'SERVICIO_NORMAL':     'Svc Normal',
      'SERVICIO_SALESFORCE': 'Svc Salesforce',
    };
    const tipoClases: {[k: string]: string} = {
      'OP_NORMAL':           'tc-op-normal',
      'OP_PARCIAL':          'tc-op-parcial',
      'CROSSDOCKING':        'tc-crossdocking',
      'SERVICIO_NORMAL':     'tc-svc-normal',
      'SERVICIO_SALESFORCE': 'tc-svc-salesforce',
    };

    // Agrupar dept → municipio → filas por tipo (la API ya no envía fila TOTAL DTO)
    const deptMap = new Map<string, Map<string, any[]>>();
    data.forEach(item => {
      const dept = item.DEPARTAMENTO_DESPACHO;
      const mun  = item.MUNICIPIO_DESPACHO;
      if (!deptMap.has(dept)) deptMap.set(dept, new Map());
      const munMap = deptMap.get(dept)!;
      if (!munMap.has(mun)) munMap.set(mun, []);
      munMap.get(mun)!.push(item);
    });

    let html = '<div class="detalle-geografico"><h3 class="seccion-titulo">🌍 Distribución Geográfica</h3><div class="departamentos-grid">';

    deptMap.forEach((munMap, departamento) => {
      // Totales del departamento = suma de todas las filas
      let totalCubicajeDept = 0;
      let totalOrdenesDept  = 0;
      munMap.forEach(rows => rows.forEach(r => {
        totalCubicajeDept += Number(r.SUM_CUBICAJE_TOTAL) || 0;
        totalOrdenesDept  += Number(r.CANT_ORDENES)       || 0;
      }));

      const cubicajePct = this.getPorcentajeNum(totalCubicajeDept, cubicajeMax);
      const ordenesPct  = this.getPorcentajeNum(totalOrdenesDept,  ordenesMax);

      html += `<div class="departamento-card">`;
      html += `<div class="dept-header">`;
      html += `<h4 class="dept-nombre">${departamento}</h4>`;
      html += `<div class="dept-totales">${totalCubicajeDept.toFixed(2)} m³ • ${totalOrdenesDept} órdenes</div>`;
      html += `</div>`;

      html += '<div class="dept-metricas">';
      html += '<div class="mini-metrica"><span class="mini-label">Cubicaje</span>';
      html += `<div class="mini-progress ${this.getAlertaClass(cubicajePct)}" style="width:${cubicajePct}%">`;
      html += `<span class="mini-text">${this.getPorcentaje(totalCubicajeDept, cubicajeMax)}%</span></div></div>`;
      html += '<div class="mini-metrica"><span class="mini-label">Órdenes</span>';
      html += `<div class="mini-progress ${this.getAlertaClass(ordenesPct)}" style="width:${ordenesPct}%">`;
      html += `<span class="mini-text">${this.getPorcentaje(totalOrdenesDept, ordenesMax)}%</span></div></div></div>`;

      html += '<div class="municipios-detalle">';
      munMap.forEach((rows, municipio) => {
        const munCub = rows.reduce((s, r) => s + (Number(r.SUM_CUBICAJE_TOTAL) || 0), 0);
        const munOrd = rows.reduce((s, r) => s + (Number(r.CANT_ORDENES)       || 0), 0);
        const munCubPct = this.getPorcentajeNum(munCub, cubicajeMax);
        const munOrdPct = this.getPorcentajeNum(munOrd, ordenesMax);

        html += `<div class="municipio-row">`;
        html += `<div class="municipio-info">`;
        html += `<span class="mun-nombre">${municipio}</span>`;
        html += `<span class="mun-datos">${munCub.toFixed(1)} m³ • ${munOrd} órdenes</span>`;
        html += `</div>`;
        html += '<div class="municipio-metricas">';
        html += `<div class="mun-metrica"><span class="mun-label">Cubicaje</span>`;
        html += `<div class="mun-progress ${this.getAlertaClass(munCubPct)}" style="width:${munCubPct}%">`;
        html += `<span class="mun-text">${this.getPorcentaje(munCub, cubicajeMax)}%</span></div></div>`;
        html += `<div class="mun-metrica"><span class="mun-label">Órdenes</span>`;
        html += `<div class="mun-progress ${this.getAlertaClass(munOrdPct)}" style="width:${munOrdPct}%">`;
        html += `<span class="mun-text">${this.getPorcentaje(munOrd, ordenesMax)}%</span></div></div></div>`;

        // Desglose por TIPO_ORDEN dentro del municipio
        html += '<div class="tipo-breakdown">';
        rows.forEach(r => {
          const tipo    = r.TIPO_ORDEN || 'SIN_TIPO';
          const clase   = tipoClases[tipo] || 'tc-default';
          let   label   = tipoLabels[tipo] || tipo.replace(/_/g, ' ');
          const tipoSol = r.TIPO_SOL as string | undefined;
          if (tipoSol && this.TIPO_SOL_LABELS[tipoSol]) {
            label += ` (${this.TIPO_SOL_LABELS[tipoSol]})`;
          }
          html += `<span class="tipo-chip ${clase}">`;
          html += `<span class="tipo-chip-dot"></span>`;
          html += `${label}: ${r.CANT_ORDENES} ord. / ${Number(r.SUM_CUBICAJE_TOTAL || 0).toFixed(2)} m³`;
          html += `</span>`;
        });
        html += '</div>';

        html += `</div>`; // municipio-row
      });
      html += '</div>'; // municipios-detalle
      html += '</div>'; // departamento-card
    });

    html += '</div></div>';
    return html;
  }

  private generarSeccionVacia(): string {
    return `
      <div class="detalle-geografico">
        <h3 class="seccion-titulo">🌍 Distribución Geográfica</h3>
        <div class="sin-datos">
          <div class="sin-datos-icon">📄</div>
          <p>No se encontraron datos geográficos para esta fecha</p>
        </div>
      </div>
    `;
  }
}

interface Item {
  cod: string;
  nombre: string;
}

interface DetalleGeografico {
  DEPARTAMENTO_DESPACHO: string;
  MUNICIPIO_DESPACHO: string;
  SUM_CUBICAJE_TOTAL: number;
  CANT_ORDENES: number;
}